var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
import { IDENTIFIERS } from '../../../types/Identifiers';
import { TAG_TYPES } from '../../../types/TagTypes';
import PROPS from '../../../types/Props';
export var GROUPS_MEDIA = {
    tags: [
        {
            type: TAG_TYPES.TITLE,
            children: '{{group.tab.title}} | {{group.name}}',
        },
        {
            type: TAG_TYPES.META,
            props: (_a = {},
                _a[PROPS.NAME] = 'description',
                _a[PROPS.CONTENT] = "{{group.description}}",
                _a),
        },
        {
            type: TAG_TYPES.META,
            props: (_b = {},
                _b[PROPS.NAME] = 'robots',
                _b[PROPS.CONTENT] = 'noindex',
                _b),
        },
        {
            type: TAG_TYPES.META,
            props: (_c = {},
                _c[PROPS.PROPERTY] = 'og:title',
                _c[PROPS.CONTENT] = "{{@" + IDENTIFIERS.TITLE + "}}",
                _c),
        },
        {
            type: TAG_TYPES.META,
            props: (_d = {},
                _d[PROPS.PROPERTY] = 'og:description',
                _d[PROPS.CONTENT] = "{{@" + IDENTIFIERS.DESCRIPTION + "}}",
                _d),
        },
        {
            type: TAG_TYPES.META,
            props: (_e = {},
                _e[PROPS.PROPERTY] = 'og:image',
                _e[PROPS.CONTENT] = '{{group.image.url}}',
                _e),
        },
        {
            type: TAG_TYPES.META,
            props: (_f = {},
                _f[PROPS.PROPERTY] = 'og:image:width',
                _f[PROPS.CONTENT] = '{{group.image.width}}',
                _f),
        },
        {
            type: TAG_TYPES.META,
            props: (_g = {},
                _g[PROPS.PROPERTY] = 'og:image:height',
                _g[PROPS.CONTENT] = '{{group.image.height}}',
                _g),
        },
        {
            type: TAG_TYPES.META,
            props: (_h = {},
                _h[PROPS.PROPERTY] = 'og:site_name',
                _h[PROPS.CONTENT] = '{{site.name}}',
                _h),
        },
        {
            type: TAG_TYPES.META,
            props: (_j = {},
                _j[PROPS.PROPERTY] = 'og:url',
                _j[PROPS.CONTENT] = '{{group.tab.url}}',
                _j),
        },
        {
            type: TAG_TYPES.META,
            props: (_k = {},
                _k[PROPS.PROPERTY] = 'og:type',
                _k[PROPS.CONTENT] = 'website',
                _k),
        },
        {
            type: TAG_TYPES.LINK,
            props: (_l = {},
                _l[PROPS.REL] = 'canonical',
                _l[PROPS.HREF] = '{{group.tab.url}}',
                _l),
        },
    ],
};
